import React from 'react';
import UpImg from '../assets/up.png';
import debounce from 'debounce';

export default function ScrollToTop({ top = 800 }){
   function scrollTop(){
       window.scrollTo(0,0);
   }

   window.onscroll = debounce(function(){
       let ref = document.getElementById("scrollToTop");
       if(!ref) return;
       if(window.scrollY > top) ref.classList.remove("d-none");
       else ref.classList.add("d-none");
   },200);

   return (
       <button id="scrollToTop" onClick={scrollTop} className="d-none" style={{zIndex:'1000'}}>
           <img src={UpImg} alt="scroll to top img"/>
       </button>
   )
}


// WEBPACK FOOTER //
// ./src/components/ScrollTop.js